import { ChangeEvent } from 'react';

import { Flex, Stack, Text, Textarea, useTheme } from '@chakra-ui/react';

interface CommentsBlockProps {
  value: string;
  label: string;
  onChange: (value: string) => void;
}

const CommentsBlock = ({ value, label, onChange }: CommentsBlockProps) => {
  const {
    colors: {
      palette: {
        booking: {
          stepReview: { commentsBlock }
        }
      }
    }
  } = useTheme();

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value);
  };

  return (
    <Stack
      px='20px'
      pt={{ base: '20px', md: '30px' }}
      pb='20px'
      bg={commentsBlock.background}
      borderRadius='6px'
      gap={0}
    >
      <Flex
        alignItems='center'
        mb={{ base: '18px', md: '25px' }}
        w='100%'
        justifyContent='center'
      >
        <Text
          fontSize={{ base: '14px', md: '16px' }}
          textTransform='uppercase'
          lineHeight='180%'
          color={commentsBlock.labelColor}
        >
          {label}
        </Text>
      </Flex>

      <Textarea
        value={value}
        onChange={handleChange}
        placeholder=' '
        borderRadius={0}
        bg={commentsBlock.textareaBackground}
        minHeight='146px'
        resize='none'
        border='1px solid'
        borderColor='transparent'
        outline='none'
        _hover={{ borderColor: 'transparent', outline: 'none' }}
        _focus={{
          borderColor: 'transparent',
          boxShadow: 'none',
          outline: 'none'
        }}
      />
    </Stack>
  );
};

export default CommentsBlock;
